import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Switch,
  Text,
  Spinner,
  FormHelperText,
  Heading,
  Divider,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { componentState } from "../../../atoms/componentState";
import TitleFlex from "./components/titleFlex";
import { NumericFormat, PatternFormat } from "react-number-format";
import { stateOptions } from "../../../constants/stateOptions";
import moment from "moment";
import { dateForAPI, dateForValueInput } from "../../../constants/dataFormat";
import { cnpj as cnpjValidator, cpf as cpfValidator } from "cpf-cnpj-validator";
import { JWTToken } from "../../../routes/privateRoute";
import jwt_decode from "jwt-decode";
import VendasBoletoIndividualApi from "../../../services/VendasBoletoIndividuaApi";
import ModalRevisãoVendaBoleto from "./components/ModalRevisãoVendaBoleto";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { goToVendaBolePixListagem } from "../../../routes/coordinator";
import { customColors } from "../../../atoms/customColors";
import { useSetRecoilState, useRecoilState } from "recoil";
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";

export interface VendaBoleto {
  idCliente: number;
  valor: number;
  vencimento: string;
  descricao: string;
  cpfPagador: string;
  nomePagador: string;
  emailPagador: string;
  enderRua: string;
  enderBairro: string;
  enderCEP: string;
  enderCidade: string;
  enderComplemento: string;
  enderEstado: string;
  enderNumero: string;
  enderReferencia: string;
  permitirRegras: boolean;
  RegrasJuros: {
    mode: string;
    amount: number;
    percentage: number;
    start_date: string;
  };
  RegrasMulta: {
    mode: string;
    amount: number;
    percentage: number;
    start_date: string;
  };
}

interface BoletoModal {
  idLogin: number;
  idCliente: number;
  dataVencimento: string;
  dataEmissao: string;
  isAvulso: boolean;
  valor: number;
  mensagem: string;
  cpfPagador: string;
  nomePagador: string;
  emailPagador: string;
  enderRua: string;
  enderBairro: string;
  enderCEP: string;
  enderCidade: string;
  enderComplemento: string;
  enderEstado: string;
  enderNumero: string;
  enderReferencia: string;
  permitirRegras: boolean;
  RegrasJuros: {
    mode: string;
    amount: number;
    percentage: number;
    start_date: string;
  };
  RegrasMulta: {
    mode: string;
    amount: number;
    percentage: number;
    start_date: string;
  };
}

export default function VendasBolePix() {
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Venda no Boleto");
  }, []);
  const navigate = useNavigate();
  const colors = useRecoilState(customColors)[0];
  const user = useRecoilState(LoggedUser)[0];
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const selectedId = useRecoilState(selectedClientHeader)[0];
  //const cliente = Number(jwtToken.idCliente);
  const cliente =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  const login = Number(jwtToken.primarysid);
  const unMask = (value: any) => {
    return value.replace(/[^0-9]/g, "");
  };

  const initialValues = {
    idCliente: 0,
    idLogin: 0,
    valor: 0,
    vencimento: "",
    descricao: "",
    cpfPagador: "",
    nomePagador: "",
    emailPagador: "",
    enderRua: "",
    enderBairro: "",
    enderCEP: "",
    enderCidade: "",
    enderComplemento: "",
    enderEstado: "AC",
    enderNumero: "",
    enderReferencia: "",
    permitirRegras: false,
    RegrasJuros: {
      mode: "SEM_JUROS",
      amount: 0,
      percentage: 0,
      start_date: "",
    },
    RegrasMulta: {
      mode: "SEM_MULTA",
      amount: 0,
      percentage: 0,
      start_date: "",
    },
  };

  const [boleto, setBoleto] = useState<VendaBoleto>(initialValues);
  function onChangeValorFixo(e: any) {
    setBoleto({
      ...boleto,
      valor: Number(e.target.value.slice(3).replace(",", ".")),
    });
  }

  const [objetoModal, setObjetoModal] = useState<BoletoModal | null>(null);
  const [responseToModal, setResponseToModal] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [loadingState, setLoadingState] = useState(false);

  async function onSubmit() {
    const valorMinimo = boleto.permitirRegras ? 10 : 5;

    if (boleto.valor < valorMinimo) {
      setLoadingState(false);
      toast.error("O boleto deve ter um valor maior ou igual ao mínimo!");
      return;
    }

    const maxDailyPercentage = parseFloat((boleto.valor * 0.033).toFixed(2));
    const maxFixedPenalty = parseFloat((boleto.valor * 0.02).toFixed(2));

    const isInvalid =
      (boleto.RegrasJuros.mode === "DAILY_PERCENTAGE" &&
        (boleto.RegrasJuros.percentage <= 0 ||
          boleto.RegrasJuros.percentage > maxDailyPercentage)) ||
      (boleto.RegrasJuros.mode === "MONTHLY_PERCENTAGE" &&
        (boleto.RegrasJuros.percentage <= 0 ||
          boleto.RegrasJuros.percentage > 1)) ||
      (boleto.RegrasMulta.mode === "PERCENTAGE" &&
        (boleto.RegrasMulta.percentage <= 0 ||
          boleto.RegrasMulta.percentage > 2)) ||
      (boleto.RegrasMulta.mode === "FIXED" &&
        (boleto.RegrasMulta.amount < 0 ||
          boleto.RegrasMulta.amount > maxFixedPenalty));

    if (isInvalid) {
      toast.error("Os valores de juros e multa estão fora do permitido.");
      return;
    }

    const objeto = {
      idCliente: cliente,
      idLogin: login,
      dataVencimento: boleto.vencimento,
      dataEmissao: moment().format(dateForAPI),
      isAvulso: true,
      valor: parseFloat(boleto.valor.toFixed(2)),
      mensagem: boleto.descricao,
      cpfPagador: unMask(boleto.cpfPagador),
      nomePagador: boleto.nomePagador,
      emailPagador: boleto.emailPagador,
      enderRua: boleto.enderRua,
      enderBairro: boleto.enderBairro,
      enderCEP: unMask(boleto.enderCEP),
      enderCidade: boleto.enderCidade,
      enderComplemento: boleto.enderComplemento,
      enderEstado: boleto.enderEstado,
      enderNumero: boleto.enderNumero,
      enderReferencia: boleto.enderReferencia,
      permitirRegras: boleto.permitirRegras,
      RegrasJuros: {
        mode: boleto.RegrasJuros.mode,
        amount: boleto.RegrasJuros.amount,
        percentage: boleto.RegrasJuros.percentage,
        start_date: boleto.vencimento,
      },
      RegrasMulta: {
        mode: boleto.RegrasMulta.mode,
        amount: boleto.RegrasMulta.amount,
        percentage: boleto.RegrasMulta.percentage,
        start_date: boleto.vencimento,
      },
    };

    setObjetoModal(objeto);
    setIsOpen(true);
  }

  async function postPayment(obj: any) {
    setLoadingState(true);
    try {
      setObjetoModal(obj);
      const response = await VendasBoletoIndividualApi.postVendaBolePix(obj);
      setResponseToModal(response);
      setBoleto(initialValues);
      setIsOpen(true);
      toast.success("Boleto criado com sucesso!");
    } catch (error: any) {
      setIsOpen(false);
      if (error.response && error.response.data && error.response.data._error) {
        const { message, reasons } = error.response.data._error.error;
        const errorTranslations: { [key: string]: string } = {
          "Late fee mode is not valid": "O modo de multa está inválido",
          "Late fee start date must be greater than the expiration date":
            "A data de início da multa deve ser maior que a data de vencimento",
          "Interest mode is not valid": "O modo de juros está inválido",
          "Invalid value fields": "Campos de valor inválidos",
          "Amount is more than limit": "O valor excede o limite permitido",
        };
        const translatedReasons = reasons.map(
          (reason: string) => errorTranslations[reason] || reason
        );
        toast.error(
          `Erro ao gerar o boleto: ${message}. Motivos: ${translatedReasons.join(
            "; "
          )}`
        );
      } else {
        const errorMessage =
          error.response?.data?.message || JSON.stringify(error);
        toast.error(errorMessage);
      }
    } finally {
      setLoadingState(false);
    }
  }

  const [validation, setValidation] = useState(false);

  function validateCPForCNPJ(item: any) {
    const temp = unMask(item);
    if (temp.length === 11) {
      if (cpfValidator.isValid(temp) === false) {
        setValidation(true);
      } else {
        setValidation(false);
      }
    } else {
      if (cnpjValidator.isValid(temp) === false) {
        setValidation(true);
      } else {
        setValidation(false);
      }
    }
  }

  async function addressCep(cep: any) {
    try {
      if (unMask(cep).length >= 8) {
        let req = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
        setBoleto((value) => ({
          ...value,
          enderRua: req.data.logradouro,
          enderBairro: req.data.bairro,
          enderCEP: req.data.cep,
          enderCidade: req.data.localidade,
          enderComplemento: req.data.complemento,
          enderEstado: req.data.uf,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  }

  // Fim de semana e feriado são vencimentos VÁLIDOS desde 24/08/2026 — a trava
  // era herança do fluxo de transferência, onde o dia útil importa. O corte das
  // 16h para vencimento no mesmo dia continua valendo.
  const aoEscolherVencimento = (e: any) => {
    if (!validarMesmoDiaEAntesDasDezesseisHoras(e.target.value)) {
      toast.error(
        "Não é possível realizar solicitações para o mesmo dia após as 16hs!"
      );
      return;
    }

    setBoleto({
      ...boleto,
      vencimento: moment(e.target.value).format(dateForAPI),
    });
  };

  function validarMesmoDiaEAntesDasDezesseisHoras(data: any) {
    const horaDaSolicitacao = moment().format("HH.mm");
    const diadaSolicitação =
      moment().format("DD-MM-YYYY") === moment(data).format("DD-MM-YYYY");
    if (diadaSolicitação) {
      if (Number(horaDaSolicitacao) < 16) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  function validaData(item: any) {
    if (moment(item) < moment().startOf("day")) {
      toast.error("A data não pode ser anterior ao dia de hoje!");
    }
  }

  const OPTIONS_INTEREST = [
    { key: 1, value: "SEM_JUROS", text: "Sem juros" },
    { key: 2, value: "DAILY_AMOUNT", text: "Valor diário" },
    { key: 3, value: "DAILY_PERCENTAGE", text: "Percentual diário" },
    { key: 4, value: "MONTHLY_PERCENTAGE", text: "Percentual mensal" },
  ];

  const OPTIONS_MULTA = [
    { key: 1, value: "SEM_MULTA", text: "Sem Multa" },
    { key: 2, value: "FIXED", text: "Valor Fixo" },
    { key: 3, value: "PERCENTAGE", text: "Valor em Porcentagem" },
  ];

  const isFormValid = () => {
    return (
      cliente > 0 &&
      boleto.valor > 0 &&
      boleto.cpfPagador !== "" &&
      boleto.emailPagador !== "" &&
      boleto.nomePagador !== "" &&
      boleto.enderCEP !== "" &&
      boleto.enderRua !== "" &&
      boleto.enderNumero !== "" &&
      boleto.enderBairro !== "" &&
      boleto.enderCidade !== "" &&
      boleto.enderEstado !== ""
    );
  };

  return (
    <Flex
      w={"100%"}
      h={"90vh"}
      bgColor={colors.WHITE}
      p={{ base: 4, md: 8 }}
      shadow="lg"
      overflowY="auto"
      flexDir="column"
      maxW="1400px"
      mx="auto"
    >
      <Box mb={6}>
        <Flex alignItems="center" mb={4}>
          <FaPlay color={colors.BLUEMONEDDBUTTONS} size="28px" />
          <Heading as="h1" size="lg" ml={3} color={colors.BLUEMONEDDBUTTONS}>
            Criar BOLEPIX Individual
          </Heading>
        </Flex>
        <Divider borderColor="gray.200" />
      </Box>

      {/* Informações de Pagamento */}
      <Box mb={8}>
        <TitleFlex item="Informações de Pagamento" />
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
          gap={4}
          my={4}
        >
          <GridItem>
            <FormControl isRequired>
              <FormLabel>
                Valor (mínimo R$ {boleto.permitirRegras ? "10,00" : "5,00"})
              </FormLabel>
              <NumericFormat
                decimalScale={2}
                prefix="R$ "
                value={boleto.valor}
                decimalSeparator=","
                customInput={Input}
                placeholder="R$ 0,00"
                onChange={onChangeValorFixo}
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Data de Vencimento</FormLabel>
              <Input
                type="date"
                value={moment(boleto.vencimento).format(dateForValueInput)}
                min={moment().startOf("day").format(dateForValueInput)}
                onChange={aoEscolherVencimento}
                onBlur={(e) => validaData(e.target.value)}
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl>
              <FormLabel>Descrição</FormLabel>
              <Input
                placeholder="Opcional"
                value={boleto.descricao}
                onChange={(e) =>
                  setBoleto({ ...boleto, descricao: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Box>

      {/* Regras do Boleto */}
      <Box mb={8}>
        <Flex alignItems="center" mb={4}>
          <Switch
            size="md"
            mr={3}
            isChecked={boleto.permitirRegras}
            onChange={() =>
              setBoleto({ ...boleto, permitirRegras: !boleto.permitirRegras })
            }
          />
          <Text fontWeight="medium">Aplicar Regras de Juros e Multa</Text>
        </Flex>
        {boleto.permitirRegras && (
          <>
            <TitleFlex item="Regras do Boleto" />
            <Box pl={4} mb={4}>
              <Text fontStyle="italic" fontSize="sm" color="gray.600">
                Multa: valor fixo em R$ ou %, aplicado após o vencimento.
              </Text>
              <Text fontStyle="italic" fontSize="sm" color="gray.600">
                Juros: valor em R$ ou %, aplicado diária ou mensalmente a partir
                do vencimento.
              </Text>
              <Text fontStyle="italic" fontSize="sm" color="gray.600">
                A contagem inicia na data de vencimento do boleto.
              </Text>
            </Box>
            <Grid
              templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
              gap={4}
              my={4}
            >
              <GridItem>
                <FormControl>
                  <FormLabel>Regras de Juros</FormLabel>
                  <Select
                    value={boleto.RegrasJuros.mode}
                    onChange={(e) =>
                      setBoleto({
                        ...boleto,
                        RegrasJuros: {
                          ...boleto.RegrasJuros,
                          mode: e.target.value,
                        },
                      })
                    }
                  >
                    {OPTIONS_INTEREST.map((item) => (
                      <option key={item.key} value={item.value}>
                        {item.text}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                {boleto.RegrasJuros.mode === "DAILY_PERCENTAGE" && (
                  <FormControl mt={4}>
                    <FormLabel>Percentual Diário (%)</FormLabel>
                    <FormHelperText color="red.500">
                      Máximo{" "}
                      {(boleto.valor * 0.033).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </FormHelperText>
                    <NumericFormat
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale
                      allowNegative={false}
                      customInput={Input}
                      value={boleto.RegrasJuros.percentage}
                      placeholder="0,00"
                      isAllowed={({ floatValue }) => {
                        const valorMaximo = (boleto.valor * 0.033) / 100;
                        return (
                          floatValue === undefined ||
                          (floatValue >= 0 && floatValue <= valorMaximo)
                        );
                      }}
                      onValueChange={({ value }) => {
                        let inputValue = parseFloat(value.replace(",", "."));
                        const valorMaximo = (boleto.valor * 0.033) / 100;
                        if (isNaN(inputValue) || inputValue > valorMaximo) {
                          inputValue = valorMaximo;
                        }
                        setBoleto({
                          ...boleto,
                          RegrasJuros: {
                            ...boleto.RegrasJuros,
                            percentage: inputValue,
                            amount: 0,
                          },
                        });
                      }}
                    />
                    {boleto.RegrasJuros.percentage >
                      (boleto.valor * 0.033) / 100 && (
                        <FormHelperText color="red.500">
                          Juros diários não podem exceder 0,033% do valor total.
                        </FormHelperText>
                      )}
                  </FormControl>
                )}
                {boleto.RegrasJuros.mode === "MONTHLY_PERCENTAGE" && (
                  <FormControl mt={4}>
                    <FormLabel>Percentual Mensal (%)</FormLabel>
                    <FormHelperText color="red.500">
                      Máximo 1,00%
                    </FormHelperText>
                    <NumericFormat
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale
                      allowNegative={false}
                      customInput={Input}
                      value={boleto.RegrasJuros.percentage}
                      placeholder="0,00"
                      isAllowed={({ floatValue }) => {
                        const valorMaximo = 1;
                        return (
                          floatValue === undefined ||
                          (floatValue >= 0 && floatValue <= valorMaximo)
                        );
                      }}
                      onValueChange={({ value }) => {
                        let inputValue = parseFloat(value.replace(",", "."));
                        const valorMaximo = 1;
                        if (isNaN(inputValue) || inputValue > valorMaximo) {
                          inputValue = valorMaximo;
                        }
                        setBoleto({
                          ...boleto,
                          RegrasJuros: {
                            ...boleto.RegrasJuros,
                            percentage: inputValue,
                            amount: 0,
                          },
                        });
                      }}
                    />
                    {boleto.RegrasJuros.percentage > 1 && (
                      <FormHelperText color="red.500">
                        Juros mensais não podem exceder 1%.
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
                {boleto.RegrasJuros.mode === "DAILY_AMOUNT" && (
                  <FormControl mt={4}>
                    <FormLabel>Valor Diário (R$)</FormLabel>
                    <FormHelperText color="red.500">
                      Máximo{" "}
                      {(boleto.valor * 0.00033).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </FormHelperText>
                    <NumericFormat
                      decimalScale={2}
                      prefix="R$ "
                      value={boleto.RegrasJuros.amount}
                      decimalSeparator=","
                      thousandSeparator="."
                      customInput={Input}
                      placeholder="R$ 0,00"
                      allowNegative={false}
                      fixedDecimalScale
                      isAllowed={({ floatValue }) => {
                        const valorMaximo = boleto.valor * 0.00033;
                        return (
                          floatValue === undefined ||
                          (floatValue >= 0 && floatValue <= valorMaximo)
                        );
                      }}
                      onValueChange={({ value }) => {
                        const inputValue = parseFloat(
                          value.replace("R$ ", "").replace(",", ".")
                        );
                        const valorMaximo = boleto.valor * 0.00033;
                        const sanitizedValue = Math.min(
                          Math.max(inputValue ?? 0, 0),
                          valorMaximo
                        );
                        setBoleto({
                          ...boleto,
                          RegrasJuros: {
                            ...boleto.RegrasJuros,
                            amount: sanitizedValue,
                            percentage: 0,
                          },
                        });
                      }}
                    />
                    {boleto.RegrasJuros.amount > boleto.valor * 0.00033 && (
                      <FormHelperText color="red.500">
                        Juros diários não podem exceder 0,033% do valor do
                        boleto.
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
                {boleto.RegrasJuros.mode === "SEM_JUROS" && (
                  <FormControl mt={4}>
                    <FormLabel color="gray.500">Sem Juros Aplicados</FormLabel>
                  </FormControl>
                )}
              </GridItem>
              <GridItem>
                <FormControl>
                  <FormLabel>Regra de Multa</FormLabel>
                  <Select
                    value={boleto.RegrasMulta.mode}
                    onChange={(e) =>
                      setBoleto({
                        ...boleto,
                        RegrasMulta: {
                          ...boleto.RegrasMulta,
                          mode: e.target.value,
                        },
                      })
                    }
                  >
                    {OPTIONS_MULTA.map((item) => (
                      <option key={item.key} value={item.value}>
                        {item.text}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                {boleto.RegrasMulta.mode === "SEM_MULTA" && (
                  <FormControl mt={4}>
                    <FormLabel color="gray.500">Sem Multa Aplicada</FormLabel>
                  </FormControl>
                )}
                {boleto.RegrasMulta.mode === "FIXED" && (
                  <FormControl mt={4}>
                    <FormLabel>Valor Fixo (R$)</FormLabel>
                    <FormHelperText color="red.500">
                      Máximo{" "}
                      {(boleto.valor * 0.02).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </FormHelperText>
                    <NumericFormat
                      decimalScale={2}
                      prefix="R$ "
                      value={boleto.RegrasMulta.amount}
                      decimalSeparator=","
                      thousandSeparator="."
                      customInput={Input}
                      placeholder="R$ 0,00"
                      allowNegative={false}
                      fixedDecimalScale
                      isAllowed={({ floatValue }) => {
                        const valorMaximo = boleto.valor * 0.02;
                        return (
                          floatValue === undefined ||
                          (floatValue >= 0 && floatValue <= valorMaximo)
                        );
                      }}
                      onValueChange={({ value }) => {
                        const inputValue = parseFloat(
                          value.replace("R$ ", "").replace(",", ".")
                        );
                        const valorMaximo = boleto.valor * 0.02;
                        const sanitizedValue = Math.min(
                          Math.max(inputValue ?? 0, 0),
                          valorMaximo
                        );
                        setBoleto({
                          ...boleto,
                          RegrasMulta: {
                            ...boleto.RegrasMulta,
                            amount: sanitizedValue,
                            percentage: 0,
                          },
                        });
                      }}
                    />
                    {boleto.RegrasMulta.amount > boleto.valor * 0.02 && (
                      <FormHelperText color="red.500">
                        Multa não pode exceder 2% do valor do boleto.
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
                {boleto.RegrasMulta.mode === "PERCENTAGE" && (
                  <FormControl mt={4}>
                    <FormLabel>Percentual (%)</FormLabel>
                    <FormHelperText color="red.500">
                      Máximo 2,00%
                    </FormHelperText>
                    <NumericFormat
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale
                      customInput={Input}
                      value={boleto.RegrasMulta.percentage}
                      placeholder="0,00"
                      isAllowed={({ floatValue }) => {
                        const valorMaximo = 2;
                        return (
                          floatValue === undefined ||
                          (floatValue >= 0 && floatValue <= valorMaximo)
                        );
                      }}
                      onValueChange={({ value }) => {
                        const inputValue = parseFloat(value.replace(",", "."));
                        const valorMaximo = 2;
                        const sanitizedValue =
                          isNaN(inputValue) || inputValue > valorMaximo
                            ? valorMaximo
                            : inputValue;
                        setBoleto({
                          ...boleto,
                          RegrasMulta: {
                            ...boleto.RegrasMulta,
                            percentage: sanitizedValue,
                            amount: 0,
                          },
                        });
                      }}
                    />
                    {boleto.RegrasMulta.percentage > 2 && (
                      <FormHelperText color="red.500">
                        Multa percentual não pode exceder 2%.
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
              </GridItem>
            </Grid>
          </>
        )}
      </Box>

      {/* Informações do Pagador */}
      <Box mb={8}>
        <TitleFlex item="Informações do Pagador" />
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
          gap={4}
          my={4}
        >
          <GridItem>
            <FormControl isRequired isInvalid={validation}>
              <FormLabel>CPF/CNPJ do Pagador</FormLabel>
              <PatternFormat
                customInput={Input}
                format={
                  unMask(boleto.cpfPagador).length > 11
                    ? "##.###.###/####-##"
                    : "###.###.###-###"
                }
                placeholder="Digite o CPF ou CNPJ"
                value={boleto.cpfPagador}
                onChange={(e) =>
                  setBoleto({ ...boleto, cpfPagador: e.target.value })
                }
                onBlur={(e) => validateCPForCNPJ(e.target.value)}
              />
              {validation && (
                <FormHelperText color={colors.REDMONEDD}>
                  Digite um CPF ou CNPJ válido!
                </FormHelperText>
              )}
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Nome do Pagador</FormLabel>
              <Input
                placeholder="Digite o nome"
                value={boleto.nomePagador}
                onChange={(e) =>
                  setBoleto({ ...boleto, nomePagador: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>E-mail</FormLabel>
              <Input
                type="email"
                placeholder="E-mail do Pagador"
                value={boleto.emailPagador}
                onChange={(e) =>
                  setBoleto({ ...boleto, emailPagador: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
        </Grid>
      </Box>

      {/* Endereço de Cobrança */}
      <Box mb={8}>
        <TitleFlex item="Endereço de Cobrança" />
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
          gap={4}
          my={4}
        >
          <GridItem>
            <FormControl isRequired>
              <FormLabel>CEP</FormLabel>
              <PatternFormat
                customInput={Input}
                format="#####-###"
                value={boleto.enderCEP}
                onChange={(e) => {
                  setBoleto({ ...boleto, enderCEP: e.target.value });
                  addressCep(e.target.value);
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Endereço</FormLabel>
              <Input
                value={boleto.enderRua}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderRua: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Número</FormLabel>
              <Input
                value={boleto.enderNumero}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderNumero: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl>
              <FormLabel>Complemento</FormLabel>
              <Input
                value={boleto.enderComplemento}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderComplemento: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl>
              <FormLabel>Referência</FormLabel>
              <Input
                value={boleto.enderReferencia}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderReferencia: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Bairro</FormLabel>
              <Input
                value={boleto.enderBairro}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderBairro: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Cidade</FormLabel>
              <Input
                value={boleto.enderCidade}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderCidade: e.target.value })
                }
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired>
              <FormLabel>Estado</FormLabel>
              <Select
                value={boleto.enderEstado}
                onChange={(e) =>
                  setBoleto({ ...boleto, enderEstado: e.target.value })
                }
              >
                {stateOptions.map((item, index) => (
                  <option value={item.value} key={index}>
                    {item.text}
                  </option>
                ))}
              </Select>
            </FormControl>
          </GridItem>
        </Grid>
      </Box>

      {/* Botões de Ação */}
      <Flex
        justifyContent="space-between"
        w="100%"
        mt={6}
        flexDir={{ base: "column", md: "row" }}
        gap={4}
      >
        <Button
          bgColor={colors.GRAY_DARK}
          color={colors.WHITE}
          w={{ base: "100%", md: "200px" }}
          onClick={() => goToVendaBolePixListagem(navigate)}
        >
          Cancelar
        </Button>
        <Button
          bgColor={colors.BLUEMONEDDBUTTONS}
          color={colors.WHITE}
          isDisabled={!isFormValid() || loadingState}
          w={{ base: "100%", md: "300px" }}
          onClick={async () => {
            setLoadingState(true);
            await onSubmit();
          }}
        >
          {loadingState ? <Spinner size="sm" /> : "Criar Boleto"}
        </Button>
      </Flex>

      <ModalRevisãoVendaBoleto
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        objeto={objetoModal}
        response={responseToModal}
        setResponseToModal={setResponseToModal}
        setBoleto={setBoleto}
        initialValues={initialValues}
        setLoadingState={setLoadingState}
      />
    </Flex>
  );
}
